import styled from "styled-components"
import {
  NavBarWrapperStyles,
  NavBarInnerStyles,
  RowStyles,
  ButtonsWrapperStyles,
} from "./nav-bar-styles"
import { BreakPoints, media } from "../../helpers/rwd"

export const NavBarWrapper = styled.div`
  display: flex;
  ${media.max(BreakPoints.desktop)} {
    display: none;
  }
  ${NavBarWrapperStyles}
`

export const NavBarInner = styled.div`
  display: flex;
  z-index: 1;
  ${NavBarInnerStyles}
`

export const Row = styled.div`
  display: flex;
  z-index: 1;
  ${RowStyles}
`

export const ButtonsWrapper = styled.div`
  display: flex;
  ${ButtonsWrapperStyles}
`
